import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdMan3,
  MdSupport,
} from 'react-icons/md';

// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/index';
import ProductTable from "views/admin/Products/productTable";
import { MdInventory2 } from "react-icons/md";
import AddProduct from 'views/admin/Products/AddProduct';
import ServiceCallTable from 'views/admin/Servicecall/ServicecallTable';
import ServiceCallReportTable from 'views/admin/Servicecall/ServiceCallReportTable';
import WithAuthProtection from 'views/auth/withauthprotection/withauthprotection';
import invoiceTable from 'views/admin/Invoice/invoiceTable';
import InvoiceTable from 'views/admin/Invoice/invoiceTable';
import CustomerTable from 'views/admin/customer/customer';
import SettingsPage from 'views/admin/main/profile/settings';
import { SettingsIcon } from '@chakra-ui/icons';
import TypesTable from 'views/admin/type/types';
import { useAuth } from 'contexts/authContext';
const CustomerRoutes = [
  {
    name: "Quotation",
    layout: "/admin",
    path: "/quotation",
    icon: (
      <Icon
        as={MdInventory2}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection>
        <InvoiceTable />
      </WithAuthProtection>
  },
  {
    name: "Service Call",
    layout: "/admin",
    path: "/service-call",
    icon: (
      <Icon
        as={MdSupport}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection>
        <ServiceCallTable />
      </WithAuthProtection>
    //  <ServiceCallTable />,
  },
  {
    name: "Service Call Report",
    layout: "/admin",
    path: "/service-call-report",
    icon: (
      <Icon
        as={MdSupport}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection>
        <ServiceCallReportTable />
      </WithAuthProtection>
  },

  {
    name: "Customer",
    layout: "/admin",
    path: "/customer",
    icon: (
      <Icon
        as={MdMan3}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection >
        <CustomerTable />
      </WithAuthProtection>
    //  <ServiceCallTable />,
  },
  {
    name: 'Profile Settings',
    layout: '/admin',
    path: '/profile-settings',
    icon: <Icon as={SettingsIcon}
      width="20px" height="20px" color="inherit" />,
    component: (
      <WithAuthProtection>
        <SettingsPage />
      </WithAuthProtection>
    ),
  },

];
const AdminRoutes = [
  // --- Dashboards ---
  {
    name: 'Dashboards',
    layout: '/admin',
    path: '/dashboards',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component:
      <WithAuthProtection >
        <DashboardsDefault />,
      </WithAuthProtection>
  },
  {
    name: "Quotation",
    layout: "/admin",
    path: "/quotation",
    icon: (
      <Icon
        as={MdInventory2}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection >
        <InvoiceTable />
      </WithAuthProtection>
  },
  {
    name: "Service Call",
    layout: "/admin",
    path: "/service-call",
    icon: (
      <Icon
        as={MdSupport}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection>
        <ServiceCallTable />
      </WithAuthProtection>
  },
  {
    name: "Service Call Report",
    layout: "/admin",
    path: "/service-call-report",
    icon: (
      <Icon
        as={MdSupport}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection>
        <ServiceCallReportTable />
      </WithAuthProtection>
  },

  {
    name: "Customer",
    layout: "/admin",
    path: "/customer",
    icon: (
      <Icon
        as={MdMan3}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component:
      <WithAuthProtection >
        <CustomerTable />
      </WithAuthProtection>

  },
  {
    name: 'Profile Settings',
    layout: '/admin',
    path: '/profile-settings',
    icon: <Icon as={SettingsIcon}
      width="20px" height="20px" color="inherit" />,
    component: (
      <WithAuthProtection >
        <SettingsPage />
      </WithAuthProtection>
    ),
  },

  {
    name: ' Types',
    layout: '/admin',
    path: '/types',
    icon: <Icon as={MdInventory2}
      width="20px" height="20px" color="inherit" />,
    component: (
      <WithAuthProtection allowedRoles={['admin']}>
        <TypesTable />
      </WithAuthProtection>
    ),
  },

];

const useAppRoutes = () => {
  const { role } = useAuth();

  if (role === "Admin") {
    return AdminRoutes;
  } else {
    console.log("Loading CustomerRoutes");
    return CustomerRoutes;
  }

};
export default useAppRoutes;